import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'byRace',
  pure: false,
  standalone: false
})
export class ByRacePipe implements PipeTransform {
  public transform(items: any[], value: any): any[] {
    return value === null ? items : items.filter((item) => item.Race === value);
  }
}
